<template>
    <div id="page-section" ref="fullScreenElement">
        <link rel="canonical" href="https://getbootstrap.com/docs/5.1/examples/dashboard/">
        <link href="../../assets/dist/css/bootstrap.min.css" rel="stylesheet">


        <!-- half lock faded zoom-->
        <div id="lock-image-container"> 
            <img id="lock-image" src="../../assets/images/lock-half-faded-zoom.png" /> 
        </div>

        <!-- Vitrafy logo (bottom right) -->
        <img id="vitrafy-logo" src="../../assets/images/vitrafy-logo-black.png" />

        <!-- header -->
        <header id="page-header" class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow page-header">

            <!-- Vitrafy logo -->
            <div id="lifechain-logo" class="navbar-brand col-md-3 col-lg-2 d-md-block logo-link">

                <img class="lifechain-image" src="../../assets/images/LifeChain_Logo_Inverted.png" />

            </div>
            <div class="nav-buttons">

                <!-- settings menu -->
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" right no-caret>
                    <template #button-content>
                        <i class="fa-solid fa-gear header-icons" style="padding-left:0"></i>
                    </template>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item href="#">
                        <div @click="toggleFullScreen()">Fullscreen <i class="fa-solid fa-expand"></i></div>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                </b-dropdown>

                <!-- help menu -->
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" right no-caret>
                    <template #button-content>
                        <i class="fa-regular fa-circle-question header-icons" style="padding-left:0"></i>
                    </template>
                    <b-dropdown-text>Help.</b-dropdown-text>
                    <b-dropdown-divider></b-dropdown-divider>
                </b-dropdown>

                <!-- notifications -->
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" right no-caret>
                    <template #button-content>
                        <font-awesome-icon icon="fa-regular fa-bell" class="header-icons" />
                    </template>
                    <b-dropdown-text>No Notifications</b-dropdown-text>
                </b-dropdown>

                <!-- user menu -->
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" right no-caret>
                    <template #button-content>
                        <font-awesome-icon icon="fa-regular fa-user" class="header-icons" style="padding-left:0" />
                    </template>
                    <b-dropdown-text>Signed in as <b>{{ userName }}</b></b-dropdown-text>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item href="/"><i class="fa-solid fa-house"></i>&nbsp;&nbsp;&nbsp;Home</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item href="/logout"><i class="fa-solid fa-right-from-bracket"></i>&nbsp;&nbsp;&nbsp;Sign
                        out</b-dropdown-item>
                </b-dropdown>
            </div>
        </header>

        <!-- main content -->
        <div class="container-fluid">

            <!-- pages -->
            <main id="dashboard-container" class="col-md-auto ms-sm-auto col-lg-11 px-md-1">
                <div class="section-container" style="margin-bottom: 100px;">
                    <!-- Check if user is logged-in -->
                     <b-alert
                        :show="dismissCountDown"
                        dismissible
                        variant="info"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                        style="margin-top: 5px;"
                    >
                        <p>User session is expired. Please <a href="/logout">log-in</a> again to continue. Redirecting to log-in page in {{ dismissCountDown }} seconds...</p>
                        <b-progress
                            variant="info"
                            :max="dismissSecs"
                            :value="dismissCountDown"
                            height="4px"
                        ></b-progress>
                    </b-alert>

                    <!-- heading -->
                    <div
                        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                        <h1 class="h2"><i :class="'fa-solid fa-' + headerIcon" style="padding-right: 10px"></i> {{
                            headerTitle
                        }}
                        </h1>
                    </div>

                    <div id="dashboard-grid-container" class="grid-container">
                        <div class="clickable-tiles-container" v-if="mainActive">
                            <clickable-tile v-for="(tile, index) in filteredTilesByPermission" :key="index"
                                :title="tile.title" :description="tile.description" :icon="tile.icon"
                                :action_items="tile.action_items" @toggle-content="showTileContent(index)"
                                :class="{ active: activeTile === index }"
                                :year="tile.year"
                                :disabled="tile.disabled" />
                        </div>
                        <div v-for="(tile, index) in filteredTilesByPermission" :key="index">
                            <transition name="tile-content">
                                <tile-content v-if="activeTile === index" :title="tile.title" :description="tile.description" :tiles="tiles" @toggle-back="resetActiveTile()" :year="tile.year" />
                            </transition>
                        </div>
                    </div>
                </div>
            </main>

            <!-- Footer -->
            <footer id="footer" class="footer mt-auto main-footer">
                <div class="container">
                    <span id="footer-copyright" style="color: hsla(0,0%,100%,.55);">{{`Copyright © ${new Date(Date.now()).getFullYear()} Vitrafy Life Sciences Ltd`}}</span>
                    <span id="footer-version" style="color: hsla(0,0%,100%,.55); float: left;">Aquaculture Dashboard Version {{ version }}</span>
                </div>
            </footer>

        </div>
    </div>
</template>

<script>
import AquacultureTile from './AquacultureTile.vue';
import AquacultureContent from './AquacultureContent.vue';
import UserInfoStore from '../../app/user-info-store';

export default {
    name: "AquacultureDashboard",
    components: {
        'clickable-tile': AquacultureTile,
        'tile-content': AquacultureContent,
    },
    data: function () {
        return {
            sessionExpiredTimer: null,
            dismissSecs: 30,
            dismissCountDown: 0,
            userName: "user",
            userInfo: [],
            headerTitle: "Aquaculture Dashboard",
            headerIcon: 'fish-fins',
            mainActive: true,
            version: "0.1.0-alpha",
            tiles: [ ],
            filteredTilesByPermission: [],
            activeTile: null,

            fullScreen: false,

            users: [],
            sites: [],
        }
    },
    watch: {
        async dismissCountDown (newValue) {
            // console.log("dismisscountdown value changed to: ", newValue);
            if (newValue <= 0) {
                console.log("Session expired. Redirecting to login page...");
                window.location.href = "/logout";
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.sessionExpiredTimer);
    },
    mounted: async function () {
        // Display core vue app element
        const appElement = document.getElementById('app');
        appElement.style.display = 'block';

        // heartbeat to check if user's JWT token is expired
        this.sessionExpiredTimer = setInterval(() => {
            this.checkAPIHeartBeat();
        }, 1000 * 60 * 5) // Every 5 minutes

        this.userInfo = UserInfoStore.state.cognitoInfo;
        this.userName = this.userInfo.username;
        await this.getAquacultureSettingsFromDynamo();
        this.filteredTilesByPermission = await this.getFilteredTiles();
        await this.getUsersFromDynamo();
        await this.getTasksFromDB();
        await this.getSitesFromDynamo();
    },
    methods: {
        async getAquacultureSettingsFromDynamo() {
            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                    { "TableName": "aquaculture_settings" },
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );

                this.settings = response.data.find(setting => setting.organisation == "Huon");
                this.tiles = this.settings.tiles;

            } catch (error) {
                console.log(error);
            }
        },
        async getUsersFromDynamo() {
            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_LIFECHAIN_USERS_API_URI + "/items",
                    JSON.stringify({}),
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );

                this.users = response.data.filter(user => user.huon_user);
            } catch (error) {
                console.log(error);
            }
        },
        async getSitesFromDynamo() {
            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                    { "TableName": "aquaculture_sites" },
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );

                this.sites = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getTasksFromDB() {
            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_AQUACULTURE_TASKS_API_URI + "/items",
                    JSON.stringify({}),
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );

                this.tiles.find(tile => tile.title === "Tasks").action_items = response.data.filter(task => task.status != 'Completed' && task.status != 'Canceled').length.toString();
            } catch (error) {
                console.log(error);
            }
        },
        async getFilteredTiles() {
            if (!this.userInfo.user_additional_info) return [];
            else {
                if (this.userInfo.user_additional_info.admin_user || (this.userInfo.user_additional_info.huon_user && this.userInfo.user_additional_info.user_level.includes("manager"))) return this.tiles;
                else {
                    var filteredTiles = [];
                    this.tiles.forEach(tile => {
                        tile.permissions.forEach(permission => {
                            if (
                                this.userInfo.user_additional_info.user_level.includes(permission) && // <-- Permissiosn matches the user's permission levels
                                filteredTiles.indexOf(tile) == -1 // <-- Tile isn't already on the list
                            ) filteredTiles.push(tile) // <-- Add the tile to the list
                        });
                    });
                    return filteredTiles;
                }
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        async checkAPIHeartBeat() {
            console.log("Checking API heartbeat... ", new Date().toUTCString());

            try {
                const response = await this.$http.get(
                    process.env.VUE_APP_API_HEARTBEAT_URL,
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );
                if (response) console.log("API Heartbeat OK. Response: ", response);
            } catch (error) {
                console.log("error: ", error)
                if (error.response.status === 401) {
                    console.log("API Heartbeat failed. Redirecting to login page...");
                    this.dismissCountDown = this.dismissSecs;
                    clearInterval(this.sessionExpiredTimer);
                }
                else console.log("API Heartbeat failed. Error: ", error);
            }
        },
        showTileContent(index) {
            console.log("Clicked: " + index)
            this.activeTile = index;
            this.mainActive = false;
            this.headerTitle = this.tiles[this.activeTile].title;
            this.headerIcon = this.tiles[this.activeTile].icon;
            // this.updateBreadcrumb(index);
        },
        async resetActiveTile() {
            this.activeTile = null;
            this.mainActive = true;
            this.headerTitle = "Aquaculture Dashboard";
            this.headerIcon = "fish-fins";
            await this.getTasksFromDB();
        },
        toggleFullScreen() {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();               // working full screen button 
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        }
    },
};
</script>

<style scoped>
#page-header {
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 20%), 0 3px 3px -2px rgb(0 0 0 / 14%), 0 1px 8px 0 rgb(0 0 0 / 12%) !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 58px;

}

#vitrafy-logo {
    position: fixed;
    height: 50px;
    right: 27px;
    bottom: 39px;
}

#lifechain-logo {
    margin: 0;
    max-width: 292px;
    background-color: #212529 !important;
    height: 58px;
}

.lifechain-image {
    height: 34px;
    position: absolute;
    top: 11px;
    left: 20px;
    cursor: pointer;
}

#filter-box {
    position: relative;
    float: right;
    right: 20%;
    margin-bottom: 20px;
}

.container-fluid {
    height: calc(100vh - 90px);
    overflow: auto;
    position: relative;
    top: 58px;
}


/* Transition for the tile content */
.tile-content-enter-active

/*, .tile-content-leave-active*/
    {
    transition: opacity 0.5s;
}

.tile-content-enter,
.tile-content-leave-to {
    opacity: 0;
}

@media (max-width: 767px) {

    .nav-buttons {
        padding: 10px;
        position: fixed;
        bottom: 0;
        left: 0;
        padding-bottom: 40px;
        width: 100%;
        background: #212529;
        color: #ffffff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
        box-sizing: border-box;
        margin: 0 auto;
        display: flex;
        /* justify-content: space-between; */
        justify-content: center;
    }

    .grid-container {
        max-width: 100%;
        min-width: 100%;
        padding-top: 10px;
    }

    .clickable-tiles-container {
        max-width: 100%;
        min-width: 100%;
    }

    #lock-image-container{
        display: none;
    }

}

@media screen {

    .nav-buttons {
        float: right;
        color: white;
        padding-right: 10px;
        font-size: 1.5em;
    }

    .grid-container {
        max-width: 85%;
        padding-top: 10px;
    }

    .clickable-tiles-container {
        max-width: 70%;
    }
}
</style>